import { translate } from 'hooks/useTranslate';
import { axiosV2 } from 'interceptors/axios';
import { downloadBlob } from 'utils/downloadBlob';

type DownloadPartnersTableXlsxProps = {
  fileName: string;
  societyId: string;
  categoryId?: string;
};
export const downloadPartnersTableXlsx = async ({
  fileName,
  societyId,
  categoryId,
}: DownloadPartnersTableXlsxProps) => {
  const { data } = await axiosV2.get<Blob>('/societies/partners-table-xlsx', {
    params: { societyId, ...(categoryId ? { categoryId } : {}) },
    responseType: 'blob',
  });
  downloadBlob(data, `${fileName || translate('Partners')}.xlsx`);
};
